<template>
  
     <vs-table search hoverFlat="false" :data="nwlist" style="background-color: #F2F3F4; border-radius: 20px;">
        <template slot="thead" >
          <vs-th style="padding: 0px">
          </vs-th>
          <vs-th v-for="item in header" :key="item" sort-key="name" style="padding: 0px;">
            {{item}} <span><vs-icon icon="unfold_more" size="16px"></vs-icon></span>
          </vs-th>
          <vs-th ></vs-th>
          <vs-th ></vs-th>
          <vs-th ></vs-th>
          <vs-th ></vs-th>
          <vs-th ></vs-th>
        </template>
          <template slot-scope="{data}">
            <vs-tr v-for="item in data" :key="item.id" >
                <vs-td style="width : 200px;" :data="item.type">
                  <vs-button class=" mr-2 " color="success" type="flat" icon="add_circle" @click="link(item)">View</vs-button>
                  <!-- <vs-button class="text-warning mr-2 " color="warning" type="flat" icon="create" @click="edit(item)">Edit</vs-button> -->
                  <vs-button v-if="role == 'admin'" class=" mr-2 " color="danger" type="flat" icon="delete" v-b-modal.modal-center @click="btndelnw=item" >Delete</vs-button>
              </vs-td>
              <vs-td :data="item.name">
                {{item.name}}
              </vs-td>
              <vs-td :data="item.sc">
                {{item.sc}}
              </vs-td>
              <vs-td :data="item.gwc">
                {{item.gwc}}
              </vs-td>
              <vs-td ></vs-td>
              <vs-td ></vs-td>
              <vs-td ></vs-td>
              <vs-td ></vs-td>
              <vs-td ></vs-td>
            </vs-tr>
          </template>
                <b-modal id="modal-center" centered >
    <template #modal-title>
      <b class="text-danger"> <vs-icon icon="delete" size="small" color="red"></vs-icon>Delete Network</b> 
    </template>
    <p class="my-4">Do you want to delete network?</p>
    
     <template #modal-footer="{ cancel }">
     
    
      <!-- Button with custom close trigger value -->
      <b-button id="btncancel"  variant="light" @click="cancel()">
        Cancel
      </b-button>
      <vs-button v-if="role == 'admin'" color="danger" style="border-radius: 20px;" size="sm" @click="del()" type="filled">Delete</vs-button>
    </template>
    
  </b-modal>
      </vs-table>
 
  
</template>

<script>
export default {
  name: "Network",
  data: () => ({
    nwlist: [],
    sensorlist: [],
    nw: null,
    role: '',
     header: ['Network','Sensors','Gateways'],
    btndelnw: ''
  }),
  methods: {
    link(nw){
      this.$router.push({
        name: 'ViewNetwork',
        params: {
          id: nw.id,
          name: nw.name,
          sc: nw.sc,
          gwc: nw.gwc
        }
      })
    },
    del() {
      this.delnw()
      location.reload()
    },
    delnw(){
      this.$http.post(this.$url+'networkdel', {
        name: this.btndelnw.name
      }).then(() => {
      this.$vs.notify({
        title: "Delete Network",
        text: "Complete!",
        color: "danger",
        position: "top-center",
        icon: 'check'
      })
        location.reload()
      
      })
      
    }
  },
  created() {
    this.role = this.$session.get('role')
    // console.log(this.role)
    this.$http.get(this.$url+'network/'+this.$session.get('token')).then((result)=>{
      this.nwlist = result.data
    })
  }
}
</script>

<style scoped>
.span {
  font-size: 14px;
}
#btncancel{
  background-color: #ffffff;
  border-radius: 0;
  border-color: #ffffff;
}
.vs-button{
  border-radius: 20px;
}
</style>